import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgFill } from '@chegg-ui/svg-icon';
import { DirectionalSvgIcon } from '../../styles';
var Chevron = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(DirectionalSvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M41.095 10.5c.3-.3.801-.5 1.202-.5.501 0 .902.2 1.202.5.3.3.501.8.501 1.3s-.2.9-.5 1.3L23.865 33.2c-.501.5-1.302.8-2.004.8-.7 0-1.302-.3-1.803-.8L.526 13c-.701-.7-.701-1.8 0-2.5.3-.3.801-.5 1.202-.5.5 0 .901.2 1.202.5l19.032 19.6 19.133-19.6Z"
  }));
});
Chevron.displayName = 'Chevron';
Chevron.defaultProps = {
  'aria-label': 'Chevron'
};
export default Chevron;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Chevron.js
// module id = 3751
// module chunks = 11